var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6286 6.00776L8.81817 1.16582C9.21826 0.89637 9.6669 0.821737 10.081 0.897685C10.4951 0.821737 10.9437 0.89637 11.3438 1.16582L18.5334 6.00776C19.0079 6.3273 19.2923 6.86189 19.2923 7.43394V17.411C19.2923 18.3607 18.5225 19.1305 17.5729 19.1305H10.3833C10.3757 19.1305 10.368 19.1304 10.3604 19.1303H11.6162V15.2923C11.6162 14.4444 10.9288 13.7571 10.081 13.7571C9.23309 13.7571 8.54574 14.4444 8.54574 15.2923V19.1303H9.80154C9.79393 19.1304 9.7863 19.1305 9.77866 19.1305H2.58908C1.63945 19.1305 0.869629 18.3607 0.869629 17.411V7.43394C0.869629 6.86189 1.15412 6.3273 1.6286 6.00776Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.61c215b046811a205c6a18978c120699.svg";
export { ForwardRef as ReactComponent };